// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// submenu
	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item')
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ['mouseenter', 'mouseleave']
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll(
			'#privary-navigation li:has(.submenu)')
		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}
	// hover change imagen
	const activeLink = document.querySelector('#privary-navigation a.active')
	const currentMenuItem = activeLink
		? Array.from(activeLink.parentElement.parentElement.children).indexOf(
				activeLink.parentElement,
		  )
		: -1
	console.log(currentMenuItem)
	if (currentMenuItem !== -1) {
		const slides = document.querySelectorAll('.menu-hovers .slide')
		if (slides[currentMenuItem]) {
			slides[currentMenuItem].classList.add('active')
		}
	}
	const menuLinks = document.querySelectorAll(
		'#privary-navigation > .privary-navigation__item > a',
	)

	menuLinks.forEach((link, idx) => {
		link.addEventListener('mouseenter', function () {
			const hoverItem = Array.from(
				link.parentElement.parentElement.children,
			).indexOf(link.parentElement)
			console.log(hoverItem)
			document.querySelectorAll('.menu-hovers .slide').forEach((slide) => {
				slide.classList.remove('active')
			})
			const slides = document.querySelectorAll('.menu-hovers .slide')
			if (slides[hoverItem]) {
				slides[hoverItem].classList.add('active')
			}
		})
	})

	// Burger Menu Funcionality Open and Close Menu
	const btn_Menu = document.querySelectorAll('[data-ctaburger]')
	const menu_Section = document.querySelector('[data-menuburger]')
	btn_Menu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			menu_Section.classList.toggle('open')
			document.querySelector('body').classList.toggle('no-scroll')
		})
	})
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// section goto
	const all_btn = document.querySelectorAll('.btn');
	all_btn.forEach((btn) => {
			const href = btn.getAttribute('href');
			if (href && href.includes('sectiongoto#')) {
					btn.addEventListener('click', (e) => {
							e.preventDefault(); 
							const targetElement = new URL(e.target.href).hash;
							console.log(targetElement);
							animateTo(targetElement);
					});
			}
	});


	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(
		'.email-signup .input input',
	)
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'checkbox' &&
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'radio'
				) {
					allffields[j]
						.getElementsByTagName('input')[0]
						.addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j]
					.getElementsByTagName('select')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j]
					.getElementsByTagName('textarea')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}

	// Home Bubble animation functionality
	const home_bubble = document.querySelector('#home .group-start.Bubble')
	if (home_bubble) {
		const content_bubble = `
      <div id="home-bubble" class="bubble">
        <div class="bubble__img"></div>
        <div class="bubble__name">Let’s Eat!</div>
      </div>`
		home_bubble.insertAdjacentHTML('afterbegin', content_bubble)

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio >= 0.75) {
						entry.target.classList.add('expand')
					}
				})
			},
			{
				threshold: [0, 0.25, 0.5, 0.65, 0.75, 1],
			},
		)

		const bubbleElement = document.querySelector('#home-bubble')
		if (bubbleElement && window.innerWidth > 900) {
			observer.observe(bubbleElement)
		}
	}
	const bubble_section = document.querySelector('[data-bubble]')
	if (bubble_section) {
		const content_bubble = `<div class="bubble"></div>`
		bubble_section.insertAdjacentHTML('beforeend', content_bubble)
		bubble_section.parentElement.classList.add('has-bubble')

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio >= 0.25) {
						entry.target.classList.add('expand')
						entry.target.querySelector('.bubble').classList.add('expand')
					}
				})
			},
			{
				threshold: [0, 0.25, 0.5, 0.65, 0.75, 1],
			},
		)

		const bubbleElement = bubble_section.parentElement
		if (bubbleElement && window.innerWidth > 900) {
			observer.observe(bubbleElement)
		}
	}

	// Default Bubble animation functionality
	const default_bubble = document.querySelector('#default .group-start.Bubble')
	if (default_bubble) {
		const content_bubble = `
      <div class="bubble">
        <div class="bubble__img"></div>
        <div class="bubble__name">Venues</div>
      </div>`
		default_bubble.insertAdjacentHTML('afterbegin', content_bubble)

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio >= 0.75) {
						entry.target.classList.add('expand')
					}
				})
			},
			{
				threshold: [0, 0.25, 0.5, 0.65, 0.75, 1],
			},
		)

		const bubbleElement = document.querySelector('.bubble')
		if (bubbleElement && window.innerWidth > 900) {
			observer.observe(bubbleElement)
		}
	}
	// capacity chart section
	const tablesResp = document.querySelectorAll('.capacity-chat__txt table')
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			let tableresponsive = document.createElement('div')
			tableresponsive.classList.add('tableHold')
			tablei.parentNode.insertBefore(tableresponsive, tablei)
			tableresponsive.append(tablei)
			const ths = tablei.querySelectorAll('tr:first-child > *')
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td')
				let i = 0
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent)
				}
			})
			const rowHeads = tablei.querySelectorAll('tr td:first-child')
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active')
				})
			})
		})
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll('[data-accodion] .tab-js')
	normal_accordion.forEach((item, i) => {
		item.addEventListener('click', (element) => {
			element.target.classList.toggle('active')
			element.target.nextElementSibling.classList.toggle('active')
		})

		if (i == 0) item.click()
	})
})()

function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop

	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up', 'down')
		}
	}

	lastScrollTop = st <= 0 ? 0 : st
}

//animation of scroll vanilla JS
function animateTo(target) {

	const targetElement = document.querySelector(target);
	if (!targetElement) {
			console.error(`Elemento no encontrado: ${target}`);
			return;
	}

	const gotoTarget = targetElement.getBoundingClientRect().top + window.pageYOffset - 110;

	const from = window.pageYOffset;
	const to = gotoTarget;
	const duration = 1300; 
	const start = performance.now(); 

		function easeInOutQuart(t, b, c, d) {
			t /= d / 2;
			if (t < 1) return c / 2 * t * t * t * t + b;
			t -= 2;
			return -c / 2 * (t * t * t * t - 2) + b;
	}

	
	function animateScroll() {
			const currentTime = performance.now() - start;
			const progress = Math.min(currentTime / duration, 1);
			const newY = easeInOutQuart(currentTime, from, to - from, duration);
			window.scrollTo(0, newY);
			if (currentTime < duration) {
					requestAnimationFrame(animateScroll);
			}
	}

	// Iniciar la animación
	animateScroll();
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold')
let allsublinks = document.querySelectorAll('.sub-menu a')
if (allsublinks.length > 1) {
	allsublinks.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			if (ele.classList.contains('active')) {
				ev.preventDefault()
			}
		})
	})
	let toggleBtn = document.querySelector('.sub-menu__toggle')
	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open')
		})
	}
} else if (submenuHold.length > 0) {
	submenuHold[0].classList.add('hidden')
}